// extracted by mini-css-extract-plugin
module.exports = {"answers":"Answers_answers__26aM7","answer":"Answers_answer__2Impv","correct":"Answers_correct__15Pho","wrong":"Answers_wrong__2nsq3"};